import { useCallback } from 'react'
import { useParsedQuery } from '@/hooks/useParsedQuery'
import { HistoryDownloadLogReqParams } from '@/services/history/history.types'
import { FormProvider, useForm } from 'react-hook-form'
import { useGetHistoryDownloadLog } from '@/services/history/useHistoryQuries'
import { defaultValues, DownloadLogForm } from '@/pages/history/downloadLog/components/DownloadLogForm'
import { DownloadLogTable } from '@/pages/history/downloadLog/components/DownloadLogTable'
import { MenuStorage } from '@/utils/storage/MenuStorage'
import { flushSync } from 'react-dom'
import MAlert from '@/utils/modal/MAlert'
import { EMPTY_EVT_DATE_MESSAGE } from '@/services/history/consts'
import { useMenuOnSession } from '@/components/layout/MainMenuOnSessionProvider'
import { PageLayout } from '@/components/layout/PageLayout'
import { VStack } from '@musinsa/mwms-ds'
import TitleSection from '@/components/content/TitleSection'

function DownLoadLog() {
  const { reload } = useMenuOnSession()
  const { parsedQs, replaceQuery } = useParsedQuery<HistoryDownloadLogReqParams>(defaultValues)
  const form = useForm<HistoryDownloadLogReqParams>({
    defaultValues: parsedQs,
  })

  const values = form.watch()

  const { data, isError, isFetching, refetch } = useGetHistoryDownloadLog(values)

  const onSearch = useCallback((values: HistoryDownloadLogReqParams) => {
    const [startDate, endDate] = values.evtDate
    if (!startDate || !endDate) {
      MAlert.show(EMPTY_EVT_DATE_MESSAGE)
      return
    }
    MenuStorage.menuOnSession.setSearch(values)
    flushSync(() => replaceQuery(values))
    reload()
    refetch()
  }, [])

  return (
    <FormProvider {...form}>
      <PageLayout gap={16}>
        <VStack gap={12}>
          <TitleSection variant="legacy" title="다운로드 로그" />
          <DownloadLogForm onSearch={onSearch} />
        </VStack>
        {/* 재조회가 실패해도 react-query 는 직전 결과를 남긴다 — 새 조건의 결과로 오해하지 않게 비운다 */}
        <DownloadLogTable data={isError ? [] : data?.list ?? []} isLoading={isFetching} />
      </PageLayout>
    </FormProvider>
  )
}

export default DownLoadLog
